<script lang="ts">
  import Caret from "~icons/ph/caret-down";
</script>

<details>
  <summary>What happens if we counter the offer?<Caret /></summary>
  <p>
    If you object, we’ll inform the finance company of your decision, then fight to try to get you a better offer. We’ll
    keep you informed along the way and let you know if we get a new offer.
  </p>
</details>
